import React from 'react';

const TextInputField = (props) => {
    return (
        <input type={"text"} value={props.value} onChange={e => props.onChange({[props.type]: e.target.value})}/>
    );
};

export default TextInputField;